// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2c7jI","col":"Table_col__183YO","fulfillmentStatus":"Table_fulfillmentStatus__3XtEc","emailCol":"Table_emailCol__3a10I"};